import React, { useCallback, useMemo } from 'react';

import { ContextSelector, SelectedRows, TableRow } from '../../context-selector-v2';
import { ContextSelectorConfigItem } from '../types';
import { ConfigItemElementProps } from './types';

function ContextSelectorElement({
  configItem: { key, options, value },
  onChange,
}: Readonly<ConfigItemElementProps<ContextSelectorConfigItem>>): JSX.Element {
  const initialSelectedRows = useMemo<SelectedRows>(() => {
    if (!Array.isArray(value)) return {} as SelectedRows;
    if (value.length === 0) return {} as SelectedRows;
    return Object.fromEntries(value.map(r => [r.id, true])) as SelectedRows;
  }, [value]);

  const handleOnApply = useCallback<(selected: TableRow[]) => void>(
    (selected: TableRow[]) => {
      onChange(key, selected);
    },
    [key, onChange]
  );

  return <ContextSelector {...options} onView={handleOnApply} initialSelectedRows={initialSelectedRows} />;
}

export { ContextSelectorElement };
